import { inject, Injectable } from '@angular/core';
import { AuthService, BaseViewConfigService, NavigationConfig, Product, ProductExportActionConfigService, ProductExportListConfigService, ProductExportService, ProductListConfigService, ProductListV2ConfigService, ProductService, ProductSortService, ProductViewType } from 'gung-standard';
import { Observable, first, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloProductExportListConfigService extends ProductExportListConfigService {

  protected environment: NavigationConfig = inject('environment' as any, { optional: true }) as NavigationConfig | null;

  getItems(): Observable<Product[]> {
    return this.authService.getCurrentUser().pipe(
      first(),
      switchMap(user => {
        this.productListConfigService.assortmentSubject.next(user.assortment);
        if (this.digitalAssets) {
          return this.productService.getProductsForDigitalAssets(
            user.assortment,
            this.productListConfigService.displayProductsOnVariantLevel
          );
        } else {
          if (this.baseViewConfigService.productViewType === ProductViewType.productV2) {
            if ((this.environment as any).projectName === 'helo') {
              this.productListV2ConfigService.fetchProductsExpanded = true;
            }
            return this.productListV2ConfigService.getItems();
          } else {
            if ((this.environment as any).projectName === 'helo') {
              this.productListConfigService.displayProductsOnVariantLevel = true;
            }
            return this.productListConfigService.getItems();
          }
        }
      }),
      tap(_ => {
        if (!this.digitalAssets && (this.environment as any).projectName === 'helo') {
          if (this.baseViewConfigService.productViewType === ProductViewType.productV2) {
            this.productListV2ConfigService.fetchProductsExpanded = false;
          } else {
            this.productListConfigService.displayProductsOnVariantLevel = false;
          }
        }
      })
    );
  }
}
